import React from 'react';
import { Box } from '@mui/material';

export interface ListPageToolbarProps {
  children: React.ReactNode;
}

const ListPageToolbar: React.FC<ListPageToolbarProps> = ({ children }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      gap: 1,
      py: 2,
      bgcolor: 'background.default',
    }}
  >
    {children}
  </Box>
);

export default ListPageToolbar;
